if (!customElements.get('technical-performance-carousel')) {
  customElements.define(
    'technical-performance-carousel',
    class TechnicalPerformanceCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return
        this.dataset.bound = 'true'
        this.sync()

        const track = this.querySelector('.swiper')
        if (!track) return

        this.observer = new MutationObserver(() => this.sync())
        this.observer.observe(track, { attributes: true, attributeFilter: ['class'] })
      }

      disconnectedCallback() {
        this.observer?.disconnect()
        this.dataset.bound = ''
        this.progressBound = false
      }

      sync() {
        const root = this.closest('.prd-TechnicalPerformance')
        const track = this.querySelector('.swiper')
        const swiper = this.querySelector('s-carousel')?.carousel
        const active = Boolean(
          swiper && !swiper.destroyed && swiper.el?.classList.contains('swiper-initialized'),
        )

        root?.classList.toggle('prd-TechnicalPerformance--carousel', active)

        if (active) {
          track?.setAttribute('data-custom-cursor-external-el', 'carousel')
        } else {
          track?.removeAttribute('data-custom-cursor-external-el')
        }

        if (!active) {
          this.progressBound = false
          root?.classList.remove('prd-TechnicalPerformance--end')
          return
        }

        const update = () => {
          root?.classList.toggle('prd-TechnicalPerformance--end', swiper.isEnd)
        }

        if (!this.progressBound) {
          this.progressBound = true
          swiper.on('progress', update)
          swiper.on('reachBeginning', update)
          swiper.on('reachEnd', update)
          swiper.on('fromEdge', update)
          swiper.on('resize', update)
        }

        update()
      }
    },
  )
}
